import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Frases from '../views/Frases.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/frases',
    name: 'Frases',
    component: Frases
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
